<template>
  <div class="device-debug-container">
    <div class="mode-ctrl-content">
      <el-button
        type="primary"
        :class="{ active: tabCurrent == index }"
        @click="changeMode(index)"
        round
        class="btn"
        size="mini"
        v-for="(item, index) in modeBtn"
        >{{ item.label }}</el-button
      >
    </div>
  </div>
</template>
<script>
import {
  DEVICE_CONFIG,
  CTRL_MODE,
  AUTO_MODE,
  MANUAL_MODE,
} from "../type/deviceConfig";
import Core from "@/libs/src/core";
export default {
  name: "deviceDebug",
  props: {
    modeuleType: {
      type: Object,
      default() {
        return {
          id: -1,
          moduleName: "工艺参数",
          moduleType: -1,
          sn: -1,
          controls: [],
          arguments: [],
        };
      },
    },
  },
  watch: {
    modeuleType(val) {
      this.init(val);
    },
  },
  data() {
    return {
      modeBtn: [
        {
          label: "手动模式",
          val: MANUAL_MODE,
        },
        {
          label: "自动模式",
          val: AUTO_MODE,
        },
      ],
      tabCurrent: 0,
    };
  },
  created() {
    this.DPC = Core.getProvider(Core.providerTypes.DPC);
    // this.init();
  },
  methods: {
    init(val) {
      const modules = this.DPC.modules;
      const moduleTypeCategory = val;
      console.log(moduleTypeCategory);
      let ctrlMode = {};
      moduleTypeCategory.arguments.forEach((item) => {
        // 控制模式
        if (item.category == CTRL_MODE) {
          ctrlMode = item;
        }
      });
    },
    // 选择控制模式
    changeMode(index) {
      this.tabCurrent = index;
    },
  },
};
</script>
<style lang="scss" scoped>
.device-debug-container {
  .mode-ctrl-content {
    padding: 15px;
  }
  .btn {
    color: #000;
    border: 1px solid rgba(175, 210, 237, 1);
    padding: 10px 30px;
    background: #fff;
    &.active {
      background: rgba(204, 233, 255, 1);
    }
  }
}
</style>